import React from 'react'
import SidebarItems from './SidebarItems'

export default function Sidebar(props) {
    let links = [
        {
            id : 1,
            label : "Dashboard",
            path : "/dashboard"
        },
        {
            id : 2,
            label : "Customers",
            path : "/customers"
        },
        {
            id : 3,
            label : "Leads",
            path : "/leads"
        },
        {
            id : 4,
            label : "FB Lead Manager",
            path : "/fb-lead-manager"
        },
        {
            id : 5,
            label : "Users",
            path : "/users"
        }
    ]
    
    return (
        <nav className="col-md-2 d-none d-md-block bg-light sidebar">
            <div className="sidebar-sticky">
                <ul className="nav flex-column">
                    <SidebarItems items={links} active={props.active} />
                </ul>
            </div>
        </nav>
    )
}
